<template>
    <div class="o-p-info">
        <OPServiceInfo />
        <OPosterSchedule/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OPServiceInfo from '../o-p-service-info'
import OPosterSchedule from '../o-poster-schedule';

export default {
    name: 'OPInfo',
    components: {
        OPServiceInfo,
        OPosterSchedule
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        componentStyles() {
            return this.getMapConfigProp('components.OPInfo.styles') || {};
        },
        componentParams() {
            return this.getMapConfigProp('components.OPInfo.params') || {};
        },
    }
}
</script>

<style lang="scss">
@import "theme";
</style>